// src/components/StaffRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { readAuthSafe } from "../utils/auth";
import { usePermissions } from "../utils/permissions";

// ?.??"? Admin ?^- Dispatcher ????.??s,????-???_?"?
export default function StaffRoute({ children, pageId }) {
  const auth = readAuthSafe();
  const { getLevel } = usePermissions();
  const role = (auth?.user?.role || "").toLowerCase();
  const allowedByRole = role === "admin" || role === "dispatcher";
  const level = pageId ? getLevel(auth?.user?.role, pageId) : allowedByRole ? "Full" : "None";

  if ((pageId && level === "None") || (!pageId && !allowedByRole)) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

